import { SyntheticEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../components/Button';
import styled from 'styled-components';
import { Content } from '../components/Content';
import { PageTitle } from '../components/PageTitle';
import { TextCSS } from '../components/Text';
import { Input } from '../components/Input';
import { Textarea } from '../components/Textarea';
import { Description } from '../components/Description';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2vmin;
  justify-content: center;
  align-items: center;
`;
const FieldDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5vmin;
`;
const FieldLabel = styled.label`
  ${TextCSS({})}
`;
const Actions = styled.div``;

const encode = (data: Record<string, string>) => {
  return Object.keys(data)
    .map(
      (key) =>
        encodeURIComponent(key) + '=' + encodeURIComponent(data[key] as string)
    )
    .join('&');
};

export const Contact = () => {
  const [done, setDone] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', email, message }),
    })
      .then(() => {
        setEmail('');
        setMessage('');
        setDone(true);
      })
      .catch((err: unknown) => {
        console.error(err);
      });
  };

  return (
    <Content>
      <PageTitle>
        <FormattedMessage id="contact" />
      </PageTitle>
      {done ? (
        <Description>
          <FormattedMessage id="contactDone" />
        </Description>
      ) : (
        <Form onSubmit={handleSubmit}>
          <FieldDiv>
            <FieldLabel htmlFor="email">
              <FormattedMessage id="contactEmail" />
            </FieldLabel>
            <Input
              id="email"
              type="email"
              name="email"
              value={email}
              placeholder=""
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </FieldDiv>
          <FieldDiv>
            <FieldLabel htmlFor="message">
              <FormattedMessage id="contactMessage" />
            </FieldLabel>
            <Textarea
              id="message"
              name="message"
              value={message}
              placeholder=""
              required
              onChange={(e) => {
                setMessage(e.target.value);
              }}
            />
          </FieldDiv>
          <Actions>
            <Button
              type="submit"
              color="green"
              disabled={email.length === 0 || message.length === 0}
            >
              <FormattedMessage id="submit" />
            </Button>
          </Actions>
        </Form>
      )}
    </Content>
  );
};
